<script>
	var utilities = require('utilities');

	const staticHelp = false;

	module.exports = {
		props: ['account-name'],
		modelData: ['userContext'],
		components: {
			'menu-icon': require('components/svg/menu-icon.vue').default,
			'org-logo': require('components/svg/org-logo.vue').default
		},
		data: function () {
			return {
				mobileMenuOpen: false,
				staticHelp
			};
		},
		methods: {
			help: function () {
				if (staticHelp) {
					utilities.openModal('#help');
				}
			},
			openTeacherLogin: function () {
				this.closeMobileMenu();
				utilities.openModal('#teacher-login-modal');
			},
			toggleMenu: function (event) {
				if (event) {
					event.stopPropagation();
				}

				var $menu = $(this.$refs.teacherMenu),
					self = this;

				$menu.toggleClass('active');

				if ($menu.hasClass('active')) {
					$('body').one('click', function () {
						self.toggleMenu();
					});
				}
			},
			openMobileMenu: function () {
				this.mobileMenuOpen = true;
			},
			closeMobileMenu: function (focusTrigger = false) {
				this.mobileMenuOpen = false;
				const mobileTrigger = this.$refs.mobileTrigger;

				if (mobileTrigger && focusTrigger === true) {
					mobileTrigger.focus();
				}
			}
		}
	};
</script>
<style lang="sass">
	@import 'config/colors';

	.lessons-and-units-nav-content {
		position: relative;
		color: #FFF;
		height: 3.8rem;

		a {
			color: #FFF;
		}

		.top-mobile-nav-trigger {
			float: right;
		}

		.classic-logo {
			position: relative;
			display: inline-block;
			text-align: left;
			left: 0px;
			margin-left: 0px;
			width: 250px;
			z-index: 5;

			@media only screen and (min-width: 800px) {
				position: absolute;
				left: 50%;
				margin-left: -125px;
				text-align: center;
			}

			font-family: 'Arial',
			sans-serif;
			font-weight: bold;

			.logo-title {
				margin-top: 5px;
				line-height: 1.7rem;
				font-size: 1.5rem;
			}
		}

		.top-auth,
		.account-nav {
			display: none;

			@media only screen and (min-width: 1140px) {
				display: block;
			}

			text-align: right;

			.top-nav {
				width: initial;
				float: right;
				display: inherit;
			}
		}

		.back-logo-container {
			text-align: center;

			.back-logo {
				width: 12rem;
				height: 3.5rem;
				margin: .5rem 0rem 0rem 0rem;

				.back-arrow {
					float: left;
					padding-top: .8rem;
					margin-right: .5rem;
				}

				.back-logo-content {
					text-align: left;
					float: left;
				}
			}

			@media only screen and (min-width: 800px) {
				.back-logo {
					margin: .25rem 0rem;
				}
			}
		}

		.green-button {
			background-color: $c-drupal-green;

			&:hover {
				background-color: darken($c-drupal-green, 5%);
			}
		}
	}
</style>
<template>
	<div class="lessons-and-units-nav-content row">
		<a
			href="/find-content"
			class="back-logo-container column medium-6 small-12"
			rel="home">
			<div class="back-logo">
				<div class="back-arrow">←</div>
				<div class="back-logo-content">
					<div>Return to the new</div>
					<org-logo :width="172"></org-logo>
				</div>
			</div>
		</a>
		<a
			href="/lessons-and-units"
			class="classic-logo small-12"
			rel="home">
			<div class="logo-title">ReadWorks Classic</div>
			<div class="logo-sub-title">Lessons &amp; Units (print-only)</div>
		</a>
		<button
			class="top-mobile-nav-trigger nav-menu-button"
			ref="mobileTrigger"
			aria-label="Open Navigation Menu"
			:aria-expanded="`${mobileMenuOpen}`"
			aria-controls="mobile-lessons-menu"
			@click="openMobileMenu">
			<menu-icon></menu-icon>
		</button>
		<div
			v-if="userContext && !userContext.classCode"
			class="account-nav column medium-6 small-12">
			<nav class="top-nav">
				<ol class="top-nav-list">
					<li>
						<outbound-link
							href="http://about.readworks.org/teacher-guide.html"
							target="_blank"
							data-outbound-link="CLASSIC_NAV_TEACHING_TIPS"
							>Teacher Guide</outbound-link
						>
					</li>
					<li v-if="!staticHelp">
						<outbound-link
							href="https://help.readworks.org/"
							target="_blank"
							data-outbound-link="CLASSIC_NAV_HELP"
							>Help / Feedback</outbound-link
						>
					</li>
					<li
						v-if="staticHelp"
						style="cursor: pointer"
						@click="help()">
						Help / Feedback
					</li>
					<li>
						<a
							href="#"
							v-on:click.prevent="toggleMenu"
							>{{ accountName }} <span class="triangle"></span
						></a>
						<ol ref="teacherMenu">
							<li><a href="/my-account">My Account</a></li>
							<li><a href="/logout">Logout</a></li>
						</ol>
					</li>
				</ol>
			</nav>
		</div>
		<div
			v-if="!userContext || userContext.classCode"
			class="top-auth column medium-6 small-12">
			<ol
				class="top-nav-list"
				style="display: inline-block; margin-right: 1rem">
				<li v-if="!staticHelp">
					<outbound-link
						href="https://help.readworks.org/"
						target="_blank"
						data-outbound-link="CLASSIC_NAV_HELP"
						>Help / Feedback</outbound-link
					>
				</li>
				<li
					v-if="staticHelp"
					style="cursor: pointer"
					@click="help()">
					Help / Feedback
				</li>
			</ol>
			<a
				href="#"
				v-on:click.prevent="openTeacherLogin"
				class="teacher-login green-button button -ruled"
				style="color: white"
				>Educator Log In</a
			>
		</div>
		<nav
			id="mobile-lessons-menu"
			:class="['top-mobile-nav', mobileMenuOpen ? 'open' : '']">
			<button
				class="button -link mobile-close-icon"
				aria-label="Close menu"
				@click="closeMobileMenu(true)">
				×
			</button>
			<div class="mobile-nav-list -secondary">
				<ol>
					<li v-if="userContext">
						<outbound-link
							href="http://about.readworks.org/teacher-guide.html"
							target="_blank"
							data-outbound-link="CLASSIC_NAV_TEACHING_TIPS"
							>Teacher Guide</outbound-link
						>
					</li>
					<li v-if="!staticHelp">
						<outbound-link
							href="https://help.readworks.org/"
							target="_blank"
							data-outbound-link="CLASSIC_NAV_HELP"
							>Help / Feedback</outbound-link
						>
					</li>
					<li
						v-if="staticHelp"
						style="cursor: pointer"
						@click="help()">
						Help / Feedback
					</li>
				</ol>
				<ol v-if="userContext">
					<li>
						<a
							href="/my-account"
							@click="closeMobileMenu"
							>My Account</a
						>
					</li>
					<li>
						<a
							href="/logout"
							@click="closeMobileMenu"
							>Logout</a
						>
					</li>
				</ol>
				<ol v-else>
					<li>
						<span
							class="link"
							@click="openTeacherLogin"
							>Educator Log In</span
						>
					</li>
				</ol>
			</div>
		</nav>
	</div>
</template>
